export default {
  default: {
    title: 'Training & Tips',
    watchNow: 'Watch Now',
    learnMore: 'Learn More',
  },
}
